import { useContext, useMemo } from 'react';
import { ParentContext } from '../ParentContext';
import { useAppUserAccess } from './useAppUserAccess';
import { useDataModification } from './useDataModification';
import { useDataModifications } from './useDataModifications';
import { gEnums } from 'global/enums/globalEnums';
import { FrameworkContext } from '../FrameworkContent';
import { appOptions_right } from 'global/optionLists/appOptionsRight';

export const useOptionsRight = ({ rightMenu_handlers, allowSideData }) => {

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { currentSettings_state, appSettings_state, paps_state } = states
  const { propOverrideOn, directLinksOverrideOn } = appSettings_state ?? {}
  const { pathViews, pathModes, view } = paps_state ?? {}
  const { aps_global, aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appUserCollections } = aps_appUserSettings ?? {}
  const { dataModifications } = aps_global ?? {}
  const { appUser_fns } = fns

  const appUserAccess = useAppUserAccess()
  const { isSuperAdminDeveloper } = appUserAccess ?? {}
  const _allowDatabase = isSuperAdminDeveloper
  const authSettingsPermissionType = appUser_fns.validate_trueSettingsAuth(appUserAccess)
  const _viewPermissionType_settings = appUser_fns.validate_settingsAuth(appUserAccess, true)

  const allowAdmin = authSettingsPermissionType === gEnums.viewPermissionTypes.allow
  let allowSideSettings = _viewPermissionType_settings === gEnums.viewPermissionTypes.allow

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { frAllows, frInfo, fw_info, overridesChanged, showRightMenuCaptions, navigationOptions, dataOrigin } = framework_state ?? {}
  const { viewListData, viewKey } = frInfo ?? {}
  const { view: key_viewItem, uivi: viewItemKey } = fw_info ?? {}
  const { pageNavOptions } = navigationOptions ?? {}
  const { dataModification } = pageNavOptions ?? {}

  const { dmOpts } = useDataModifications()
  const additionalNavigationItems = useDataModification()

  const itemData = viewListData && viewKey && viewListData[viewKey]

  const isLanding = view === 'landing' || view === 'clients' || view === 'home'
  const allowSd = pathModes.sport || pathModes.district || pathModes.organization
  const isEvent = pathViews.events ? true : false
  const isClient = pathViews.clients && !pathViews.events

  let dashboardType;

  if (pathModes.sport) {
    dashboardType = 'Sports'
  } else if (pathModes.district) {
    dashboardType = 'District'
  } else if (pathModes.organization) {
    dashboardType = 'Organization'
  }

  const _settings = {
    _allowDatabase,
    additionalNavigationItems,
    allowAdmin,
    allowSd,
    allowSideData,
    allowSideSettings,
    appUserAccess,
    appUserAccess,
    appUserCollections,
    dataModification,
    dataModifications,
    dataOrigin,
    directLinksOverrideOn,
    dmOpts,
    frAllows,
    isClient,
    isEvent,
    isLanding,
    itemData,
    key_viewItem,
    overridesChanged,
    propOverrideOn,
    showRightMenuCaptions,
    view,
  }

  const rightOptions = useMemo(() => {

    const { allowSideSettings, allowSideData, isLanding } = _settings

    let _rightOptions = {}

    if (allowSideSettings) {
      _.forEach(appOptions_right, (alo, key) => {
        _rightOptions[key] = alo(rightMenu_handlers, _settings)
      })
    } else if (allowSideData && !isLanding && appOptions_right.data) {
      _rightOptions = {
        page: appOptions_right.data(rightMenu_handlers, _settings),
      }
    }
    return _rightOptions
  }, [_settings, key_viewItem, dmOpts])

  return rightOptions
}
